import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function AreaCard({ area, index = 0, audience }) {
  const inquiryHref = `/inquiry?service=${encodeURIComponent(area.title)}${
    audience ? `&audience=${encodeURIComponent(audience)}` : ""
  }`;
  return (
    <article
      data-testid={`area-card-${area.id}`}
      className="wt-service-card"
      aria-labelledby={`area-${area.id}-title`}
    >
      <div className="flex items-center justify-between">
        <span className="wt-eyebrow">{`0${index + 1}`}</span>
        <span className="text-[10px] tracking-[0.16em] uppercase wt-text-muted">Area</span>
      </div>
      <h3 id={`area-${area.id}-title`} className="wt-h3 mt-1">
        {area.title}
      </h3>
      <p className="wt-body wt-text-muted">{area.short}</p>
      <div className="mt-auto pt-3 flex items-center justify-between gap-3">
        <Link
          to={inquiryHref}
          data-testid={`area-card-cta-${area.id}`}
          className="inline-flex items-center gap-1.5 text-sm font-semibold wt-primary group"
        >
          <span className="wt-link">Submit an Inquiry</span>
          <ArrowUpRight
            size={16}
            className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            aria-hidden="true"
          />
        </Link>
        <Link
          to="/book-consultation"
          data-testid={`area-card-book-${area.id}`}
          className="text-sm wt-text-muted hover:wt-primary"
        >
          Book
        </Link>
      </div>
    </article>
  );
}

AreaCard.propTypes = {
  area: PropTypes.object.isRequired,
  index: PropTypes.number,
  audience: PropTypes.string,
};
